module.exports = __webpack_public_path__ + "static/media/edit.d2673962.svg";